import { MaterialCommunityIcons } from '@expo/vector-icons';
import { Pressable, StyleSheet, Text } from 'react-native';
import { Colors } from '../../themes';

const IconSize = 18;

export type AlertsButtonProps = {
  alertsCount: number;
  assetId: string;
  name: string;
  onPress: () => void;
};

export const AlertsButton = ({
  alertsCount,
  onPress,
}: AlertsButtonProps) => {
  return (
    <Pressable
      onPress={(e) => {
        e?.stopPropagation?.();
        onPress();
      }}
      style={styles.iconRow}
    >
      <MaterialCommunityIcons
        name="alarm-check"
        color={Colors.black}
        size={IconSize}
        style={styles.icon}
      />
      <Text style={styles.greyLabel}>{String(alertsCount ?? 0)}</Text>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  iconRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    marginRight: 4,
  },
  greyLabel: {
    fontSize: 14,
    color: Colors.grey,
  },
});
